<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-29 14:16:09
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-04-20 19:14:03
 * @Description: file content
 -->
<template>

  <div class="btn_home" @click="goPage">
    <img :src="imgHost + 'goBack.png?v=' + $config.OSSVersion" />
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    goPage() {
      if (this.$route.name === 'draw' || this.$route.name === 'dzp' || this.$route.name === 'blindBox' || this.$route.name === 'secretDraw') {
        this.$router.go(-2)
      } else if(this.$route.name === 'team' || this.$route.name === 'myprize') {
        this.$goPage('index');
      } else {
        this.$router.go(-1)
      }
    }
  },
  created() {
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.btn_home {
  width: $backWidth;
  position: fixed;
  bottom: 60px;
  right: 0px;
  z-index: 90;
}
</style>